import React  from "react";
import './chart.scss'
import 'chart.js/auto';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
export default function Charts({Questionlist,ChartList})
{
return (
  <div className='feature'>
      <div className="top">
        <h1 className="title">{}</h1>      
      </div>
            <Bar width={60} height={30}
            type='bar' data={{
                  labels: ChartList.map( person => person.Des),
                  datasets: [
                  { 
                    data:ChartList.map( person => person.value),
                    backgroundColor: [
                      '#f48fb1',
                      '#81d4fa',
                      '#ffb74d',
                      '#69f0ae',
                      '#957DAD',
                      '#ffff00',
                      '#ff0000',
                      '#716c6c',
                      '#1d0ff0'
                    ],
                  }],
                  options: {
                    scales: {
                      y: {
                        beginAtZero: true
                      }
                    }
                  }
                }}
                options = {{
                  indexAxis: 'y' ,
                  elements: {
                    bar: {
                      borderWidth: 2,
                    },
                  },
                  responsive: true,
                  plugins: {
                    legend: {
                      position: 'right' ,
                      display: false
                    },
                    title: {
                      display: true,
                      text: "คำถาม : "+Questionlist.map( person => person.name),
                    },
                    tooltips: {
                        callbacks: {
                           label: function(tooltipItem) {
                                  return tooltipItem.yLabel;
                           }
                        }
                    }
                  },
                }}/>
      </div>
)
}